import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

export default function PrivacyPolicy() {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      <Header />
      <main
        style={{
          flex: '1',
          maxWidth: '900px',
          margin: '0 auto',
          padding: '2rem',
          fontFamily: 'Arial, sans-serif',
          lineHeight: '1.8',
          color: '#333'
        }}
      >
        <h1 style={{ textAlign: 'center', marginBottom: '2rem', fontSize: '2.5rem', fontWeight: 'bold' }}>
          Privacy Policy
        </h1>
	<p>
	 Honor Society Tutors, Inc. (HST) is committed to safeguarding the privacy of your information. This Privacy Policy 
	 is designed to help you understand how we collect, transmit, and store information about our users. Providing your 
	 information is voluntary and your use of the site after the effective date of this document constitutes your acceptance of this Privacy Policy.
	</p>
	<p>
	 Information We Collect
	</p>
	<p>
	 In order to help you get the most out of our service, we collect user submitted personally identifiable information 
	 when you use the site. We ask site users to submit information in order to use our service. Such information 
	 includes, but is not limited to, your name and email address. We also collect other non-identifying information 
	 that you provide as part of your use of the Site and Services, which includes but is not limited to your school, graduation 	
	 year, subject you would like to tutor. 
	</p>
	<p>
	 We may allow you to register to join the Service as a User or Tutor via our Site. We do not collect any information that 
	 is not necessary to provide and improve our Site and to enable users to enjoy and easily navigate the Site.
	</p>
	<p>
	 Information Sharing
	</p>
	<p>
	 HST shares information between Providers and Users in order to facilitate the arrangement of tutoring sessions, specifically 
	 we provide the tutor with the name and email address of the user and the subject the user needs tutoring in. HST does 
	 not disclose or sell your personally identifiable information without your consent. 
	</p>
	<p>
	 This Privacy Policy covers information collected from honorsocietytutors.com. Your use of the Honorsocietytutors.com signifies your 
	 agreement with this policy.
	</p>
      </main>
    </div>
  );
}
